<template>
    <input-basic
        class="mt-4"
        placeholder="Display name for the review"
        :modelValue="username"
        @update:modelValue="$emit('update:username', $event)"
        :error="errors['user.name']"
    />

    <input-basic
        class="mt-4"
        placeholder="Email Address"
        type="email"
        :modelValue="email"
        @update:modelValue="$emit('update:email', $event)"
        :error="errors['user.email']"
    />

    <input-error v-if="errors['user.name'] || errors['user.email']">
        Please fill in your details
    </input-error>

    <div v-if="type == 'fitter'">
        <p class="mt-4 text-dark">
            Don't worry, we won't use this for marketing or share with third parties.
            It's to confirm you're real and to get in touch with you if there's something wrong with your review.
        </p>

        <p class="mt-4 text-dark">
            However if you would like to recieve occasional emails regarding new tyres tests and news select an option below:
        </p>

        <input-radio
            class="mt-4"
            :value="true"
            name="marketing"
            :modelValue="marketing"
            @update:modelValue="$emit('update:marketing', $event)"
        >Yeah! That sounds great, sign me up!</input-radio>

        <input-radio
            class="mt-4"
            :value="false"
            name="marketing"
            :modelValue="marketing"
            @update:modelValue="$emit('update:marketing', $event)"
        >No, I'm good thanks</input-radio>
    </div>
</template>
<script>
import InputBasic from '@/Components/Forms/Inputs/InputBasic.vue';
import InputRadio from '@/Components/Forms/Inputs/InputRadio.vue';
import InputError from '@/Components/Forms/Inputs/InputError.vue';

export default {
    components: {InputBasic, InputRadio, InputError},
    emits: ['update:username', 'update:email', 'update:marketing'],
    props: {
        username: String,
        email: String,
        marketing: [Boolean, Number, String],
        errors: Object,
        type: String
    }
};
</script>


<style scoped>

</style>
